import { TailSpin } from "react-loader-spinner";

const Button = ({ text, type, onClick, isLoading, isdisabled }) => {
  return (
    <div className="flex flex-row items-center  justify-center w-full">
      <button
        type={type || "button"}
        onClick={onClick}
        disabled={isLoading || isdisabled}
        onSubmit={(e) => e.preventDefault()}
        className="bg-[#5B2E4F] w-full rounded flex justify-center space-x-5 items-center text-white px-10 py-3 text-[12px] font-[500px] leading-4"
      >
        {text || "Submit"}

        {isLoading && (
          <TailSpin
            height="20"
            width="20"
            color="white"
            ariaLabel="tail-spin-loading"
            radius="2"
            wrapperStyle={{}}
            className="pl-4"
          />
        )}
      </button>
    </div>
  );
};

export default Button;
